import { useMutation, UseMutationOptions } from 'react-query';

import { userApi } from 'src/Services/API';

export const useUpdateLastAssetDetailSelectionDate = (
  options?: UseMutationOptions<void, unknown, void>
) => {
  return useMutation<void, unknown, void>(
    ['update-last-asset-detail-selection-date'],
    async () => {
      const response = await userApi.userControllerUpdateLastAssetDetailSelectionDate();
      return response.data;
    },
    options
  );
};

export default useUpdateLastAssetDetailSelectionDate;
